import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import moment from 'moment';
import {Observable, of} from 'rxjs';

@HookClass('e06b7def-ac84-44e1-b267-be760ba2a809.date')
export class e06b7def_ac84_44e1_b267_be760ba2a809_DateHook extends BaseHook {
    @Hook('c224ccca-fedd-42ca-a292-34462a49e84f')
    public generateAvailableSlots(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const slotsAvailables = [] as any[];
        const slotsAt = moment(inputArtifact.object.config.generateSlotsAt).toDate();
        const slotsDay = slotsAt.getDay().toString();
        const weekDays = inputArtifact.object.data.weekDays;

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = {
            config: {},
            data: slotsAvailables
        };

        // se o dia da semana da data que se deseja obter os slots não estiver dentro da lista de dias, nem executa a função
        if (!weekDays.includes(slotsDay)) {
            return of(outputArtifact);
        }

        let slotAtInGetTime = new Date(slotsAt.getTime()).setUTCHours(12, 0, 0, 0);
        const worksheetStartAt = moment(inputArtifact.object.data.startAt).toDate();
        const worksheetEndAt = moment(inputArtifact.object.data.endAt).toDate();
        const zeroHour = worksheetStartAt.getUTCHours() + worksheetStartAt.getUTCMinutes() + worksheetStartAt.getUTCSeconds();
        if (zeroHour == 0) {
            slotAtInGetTime = slotAtInGetTime + 86400000;
        }

        let startAt = new Date(worksheetStartAt.getTime()).setUTCHours(0, 0, 0, 0);
        let endAt = new Date(worksheetEndAt.getTime()).setUTCHours(23, 59, 59, 0);

        // se a data que se deseja obter os slots não existir dentro do range de datas do worksheet, nem executa a função
        if (slotAtInGetTime < startAt || slotAtInGetTime > endAt) {
            return of(outputArtifact);
        }

        // verifica automaticamente pela própria configuração da worksheet se controla conflitos ou não
        let myListExistsEvents = [] as any[];
        if (!inputArtifact.object.data.isFreeSchedule && inputArtifact.object.config.excludeSlotList && inputArtifact.object.config.excludeSlotList.length > 0) {
            myListExistsEvents = inputArtifact.object.config.excludeSlotList;
            myListExistsEvents.forEach((item: any) => {
                if (typeof (item.day) == 'string')
                    item.day = moment(item.day).toDate();

                if (typeof (item.dayEnd) == 'string')
                    item.dayEnd = moment(item.dayEnd).toDate();
            });
        }

        // definir o range de horas para a data que se deseja obter os slots
        startAt = new Date(slotAtInGetTime).setUTCHours(worksheetStartAt.getUTCHours(), worksheetStartAt.getMinutes(), 0, 0);
        endAt = new Date(slotAtInGetTime).setUTCHours(worksheetEndAt.getUTCHours(), worksheetEndAt.getMinutes(), 0, 0);
        if ((endAt - startAt) < 0) {
            endAt = endAt + 86400000;
        }

        const intervalDefaultInMinutes = 1000 * 60;
        const interval = Number(inputArtifact.object.data.interval);
        const intervalIncrement = intervalDefaultInMinutes * interval;
        let dataHoraBase = startAt;

        // achar a difereça absoluta entre os horários de inicio e fim do turno dividido pela base de minutos do dia
        const diffHours = Math.abs(endAt - startAt) / intervalDefaultInMinutes;
        const totalSlotsNumber = Math.trunc(diffHours / interval);
        if (totalSlotsNumber) {
            for (let i = 0, len = totalSlotsNumber; i < len; ++i) {
                const newStartAt = new Date(dataHoraBase);
                const newEndAt = new Date(dataHoraBase + intervalIncrement);
                dataHoraBase = newEndAt.getTime();
                const verifyNewDatesInMyArray = myListExistsEvents.some(element => (newStartAt.getTime() >= element.day.getTime() && newStartAt.getTime() < element.dayEnd.getTime()) || (newEndAt.getTime() > element.day.getTime() && newEndAt.getTime() <= element.dayEnd.getTime()));
                if (!verifyNewDatesInMyArray) {
                    const newSlot = {
                        day: newStartAt,
                        dayEnd: newEndAt
                    };
                    const verifyMyArrayInNewDates = myListExistsEvents.some(element => (element.day.getTime() >= newStartAt.getTime() && element.day.getTime() < newEndAt.getTime()) || (element.dayEnd.getTime() > newStartAt.getTime() && element.dayEnd.getTime() <= newEndAt.getTime()));
                    if (!verifyMyArrayInNewDates) slotsAvailables.push(newSlot);
                }
            }
        }
        outputArtifact.object.config = {
            excludeSlotList: myListExistsEvents,
            totalSlotsNumber,
            diffHours,
            dataHoraBase,
            intervalIncrement,
            interval,
            endAt,
            startAt,
            slotAtInGetTime,
            worksheetEndAt,
            worksheetStartAt,
            weekDays,
            slotsAt,
            slotsDay,
            worksheet: inputArtifact.object.data
        };
        return of(outputArtifact);
    }
}
